import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Zap, Clock } from 'lucide-react';
import { PaymentMethods } from './ui/PaymentMethods';
export function Hero() {
  return <section className="relative min-h-[85vh] flex items-center justify-center pt-16 pb-12 md:pt-20 md:pb-16 px-4 overflow-hidden bg-hero-pattern bg-cover bg-center bg-no-repeat bg-fixed" data-id="element-79">
      <div className="absolute inset-0 bg-brand-dark/80 bg-texture opacity-50 mix-blend-overlay" data-id="element-80"></div>

      <div className="relative z-10 max-w-5xl mx-auto text-center" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-82">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-blue/20 text-brand-blue border border-brand-blue/30 text-xs md:text-sm font-bold tracking-widest uppercase mb-4 md:mb-6" data-id="element-83">
            Your Entire Coaching Career. Solved.
          </span>

          <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 md:mb-8 leading-[1.1]" data-id="element-84">
            STOP IMPROVISING <br data-id="element-85" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-orange to-orange-400 text-glow-orange" data-id="element-86">
              EVERY SESSION.
            </span>
          </h1>

          <motion.img initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} src="https://cdn.magicpatterns.com/uploads/ksvZ7GpczKeQRVKMp6NC8P/Mockup_Functional__Cross_Ready-Photoroom.png" alt="Functional & Cross Ready — 6 volumes and 5 bonuses bundle" className="w-[70%] max-w-2xl mx-auto mb-6 md:mb-8 drop-shadow-2xl" data-id="element-87" />

          <p className="sm:text-xl md:text-2xl text-zinc-300 max-w-3xl mx-auto mb-8 md:mb-10 font-medium text-[12px]" data-id="element-88">
            600+ pages, 6 complete training volumes, 5 powerful bonuses and
            everything a functional and cross training coach needs — prepared in
            minutes, executed with confidence.
          </p>

          <div className="flex flex-row flex-wrap items-center justify-center gap-x-3 gap-y-1.5 mb-5 md:mb-6 text-[11px] sm:text-xs md:text-sm font-semibold text-zinc-400" data-id="element-89">
            <span className="flex items-center gap-1.5" data-id="element-90">
              <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-blue" data-id="element-91" />
              Digital PDF
            </span>
            <span className="text-zinc-700" data-id="element-92">•</span>
            <span className="flex items-center gap-1.5" data-id="element-93">
              <Clock className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-blue" data-id="element-94" />
              Instant Access
            </span>
            <span className="text-zinc-700" data-id="element-95">•</span>
            <span className="flex items-center gap-1.5" data-id="element-96">
              <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-blue" data-id="element-97" />
              6 Volumes + 5 Free Bonuses
            </span>
          </div>

          <div className="flex flex-col items-center gap-6" data-id="element-98">
            <Button size="xl" onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-99">
              Get Instant Access Now
            </Button>

            <PaymentMethods data-id="element-100" />

            <div className="flex items-center gap-6 text-sm text-zinc-500 font-medium" data-id="element-101">
              <span className="flex items-center gap-1" data-id="element-102">
                <ShieldCheck className="w-4 h-4" data-id="element-103" /> Secure Payment
              </span>
              <span className="flex items-center gap-1" data-id="element-104">
                <Clock className="w-4 h-4" data-id="element-105" /> 7-Day Guarantee
              </span>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Decorative bottom gradient */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-brand-dark to-transparent" data-id="element-106"></div>
    </section>;
}